import React from "react";
import WhyBlackRidge from "@/components/WhyBlackRidge";

export default function HomeWhySection() {
  return (
    <section className="section-pad bg-br-paper">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">Why Black Ridge Construction</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Built for Long-Term Homeowner Relationships</h2>
        </div>
        <WhyBlackRidge />
      </div>
    </section>
  );
}
